import template from './feature-filter-icon.template.html'

/* @ngInject */
export default function featureFilterIconDirective() {
  return {
    template
  }
}
